import React from "react";
import { useTable, usePagination, useSortBy } from "react-table";
import MainTablePaginationAdvWeekly from "./tables/MainTablePaginationAdvWeekly";

function BasicDataTable({ data, columns, customPageSize = 8 }) {
  //Table start
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    state,
    setPageSize,
    canPreviousPage,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: customPageSize },
    },
    useSortBy,
    usePagination
  );

  const { pageIndex, pageSize } = state;

  return (
    <>
      <div className="table_container">
        <table {...getTableProps()} className="table mtbs">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render("Header")}
                    <i
                      className={
                        column.isSorted
                          ? column.isSortedDesc
                            ? "fi fi-rr-angle-small-down head-icon"
                            : "fi fi-rr-angle-small-up head-icon"
                          : "fi fi-rr-circle-small head-icon w"
                      }
                    ></i>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} style={{ textAlign: "center" }}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} className="main-row">
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <MainTablePaginationAdvWeekly
        nextPage={nextPage}
        previousPage={previousPage}
        canNextPage={canNextPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canPreviousPage={canPreviousPage}
        setPageSize={setPageSize}
        gotoPage={gotoPage}
        pageCount={pageCount}
      />
    </>
  );
}

export default BasicDataTable;
